import React from 'react';
import {
  Edit,
  TabbedForm,
  TopToolbar,
  FormTab,
  ShowButton,
} from 'react-admin';

import ReglaConfiguracionDeTope from './ReglaConfiguracionDeTope';
import ReglaConfiguracionGeneral from './ReglaConfiguracionGeneral';
import VersionableButton from './VersionableButton';
import ReglaEditForm from './ReglaEditForm'
import ReglaExcepcionesTab from './ReglaExcepcionesTab';
import ReglaTiposTransaccionTab from './ReglaTiposTransaccionTab';
import ReglaEtiquetasTab from './ReglaEtiquetasTab';


const ReglaEditActions = ({ basePath, data, resource }) => (
  <TopToolbar>
    <ShowButton basePath={basePath} record={data} />
    {/* Add your custom actions */}
    <VersionableButton color="primary" data={data} resource={resource} redirect={basePath} />
  </TopToolbar>
);

const ReglaEdit = (props) => {
    return (
  <Edit mutationMode="optimistic" actions={<ReglaEditActions />} {...props}>
    <TabbedForm {...props}>
        <ReglaEditForm {...props}/>
        <FormTab label="resources.regla.tabs.configuraciones" path="configuraciones">
            <ReglaConfiguracionDeTope link="edit" />
            <ReglaConfiguracionGeneral link="edit" />
        </FormTab>
        <ReglaExcepcionesTab {...props}/>
        <ReglaTiposTransaccionTab {...props}/>
        <ReglaEtiquetasTab/>
    </TabbedForm>
  </Edit>
)};

export default ReglaEdit;
